export default {
	workspace_tabs_create_actions_split_view_label: 'Open newly created objects in the side panel',
	workspace_tabs_position_bottom: 'Bottom',
	workspace_tabs_position_label: 'Tab bar position',
	workspace_tabs_position_top: 'Top',
	workspace_tabs_records_split_view_label: 'Open records in the side panel',
	workspace_tabs_responsive_exit_discard: 'Discard changes and open mobile view',
	workspace_tabs_responsive_exit_message:
		'Unsaved changes in open tabs will be lost when switching to the mobile view.',
	workspace_tabs_responsive_exit_stay: 'Stay in tab view',
	workspace_tabs_responsive_exit_title: 'Unsaved changes',
	workspace_tabs_save_and_close: 'Save and close tab',
	workspace_tabs_scroll_back: 'Scroll tabs left',
	workspace_tabs_scroll_forward: 'Scroll tabs right',
	workspace_tabs_settings_warning_accept: 'Disable',
	workspace_tabs_settings_warning_message:
		'Disabling closes all open workspace tabs. Unsaved changes in open tabs will be lost.',
	workspace_tabs_settings_warning_title: 'Disable tab workspace?',
	workspace_tabs_title_PhoneBook: 'Phone book',
	workspace_tabs_title_addon: 'Add-on',
	workspace_tabs_title_agendaList: 'Calendar',
	workspace_tabs_title_appointment: 'Appointment',
	workspace_tabs_title_contact_history: 'Contact history',
	workspace_tabs_title_document: 'Document',
	workspace_tabs_title_documentList: 'Documents',
	workspace_tabs_title_filterList: 'Filters',
	workspace_tabs_title_inbox: 'Home',
	workspace_tabs_title_kanbanBoard: 'Kanban',
	workspace_tabs_title_mail: 'Mail',
	workspace_tabs_title_mailList: 'Mails',
	workspace_tabs_title_mailSend: 'New mail',
	workspace_tabs_title_mailSendWithReceiver: 'New mail',
	workspace_tabs_title_memo: 'Memo',
	workspace_tabs_title_message: 'Message',
	workspace_tabs_title_messageList: 'Messages',
	workspace_tabs_title_note: 'Note',
	workspace_tabs_title_noteList: 'Notes',
	workspace_tabs_title_notebookList: 'Folder',
	workspace_tabs_title_organization: 'Organization',
	workspace_tabs_title_phoneCall: 'Phone call',
	workspace_tabs_title_phoneCallCreate: 'New phone call',
	workspace_tabs_title_phoneCallList: 'Calls',
	workspace_tabs_title_record: 'Record',
	workspace_tabs_title_records: 'Records',
	workspace_tabs_title_records_search: 'Search',
	workspace_tabs_title_relationsHistory: 'Relation history',
	workspace_tabs_title_settings: 'Settings',
	workspace_tabs_title_task: 'Task',
	workspace_tabs_title_taskList: 'Tasks',
	workspace_tabs_title_timer: 'Timer',
	workspace_tabs_title_trashList: 'Trash',
	workspace_tabs_title_userOnline: 'Users online',
};
